import { UiBsSignupModule } from '@wlp/ui-bs-signup';
import { UiCHeaderOnboardingModule } from '@wlp/ui-c-header-onboarding';
import { AccountAtivationPage } from './account-ativation.page';
import { AccountAtivationRoutingModule } from './account-ativation-routing.module';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from '../../../../../core/shared/modules/components.module';
import { TranslateModule } from '@ngx-translate/core';
import { UiCSwiperModule } from '@wlp/ui-c-swiper';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { CommonModule } from '@angular/common';
import { environment } from "../../../../../../environments/environment";
import { TokenValidationPage } from './token-validation/token-validation.page';
import { ReactiveFormsModule } from '@angular/forms';
import { UiCSendCodeAccountActivationModule } from '@wlp/ui-c-send-code-account-activation';
import { UiCContainerBrandModule } from '@wlp/ui-c-container-brand';
@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule,
        UiCSendCodeAccountActivationModule,
        ComponentsModule,
        AccountAtivationRoutingModule,
        UiCSwiperModule,
        ReactiveFormsModule,
        UiBsTranslateModule.forRoot({ device: 'WEB', config: environment }),
        UiCContainerBrandModule,
        UiCHeaderOnboardingModule,
    ],
    declarations: [AccountAtivationPage, TokenValidationPage]
})
export class AccountAtivationPageModule { }
